// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}
:host ion-item.item {
  --padding-start: 0;
  --padding-end: 0;
  padding-bottom: 1em;
}
:host ion-item.item.space-between-elements {
  border-bottom: 1px solid var(--ion-color-light);
}
:host ion-item.item div.podcast-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0;
  white-space: pre-wrap;
}
:host ion-item.item div.podcast-container .content {
  padding: var(--small-item-padding);
  padding-bottom: 0;
  display: flex;
  justify-content: space-between;
}
:host ion-item.item div.podcast-container .content .controls {
  margin-right: 12px;
}
:host ion-item.item div.podcast-container .content .controls ion-spinner {
  color: var(--cms-button-text-color);
  width: 1em;
}
:host ion-item.item div.podcast-container .content .controls-and-title {
  display: flex;
}
:host ion-item.item div.podcast-container .content .image {
  width: 85px;
  height: 85px;
  max-width: 85px;
  margin-right: 16px;
  flex-basis: 85px;
  flex-grow: 0;
  flex-shrink: 0;
}
:host ion-item.item div.podcast-container .content .image image-loader {
  width: 100%;
}
:host ion-item.item div.podcast-container .content .image image-loader ::ng-deep app-loading {
  width: 100%;
  min-height: initial;
}
:host ion-item.item div.podcast-container .content .image image-loader ::ng-deep img {
  border-radius: 8px;
}
:host ion-item.item div.podcast-container .content .title-and-author {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
:host ion-item.item div.podcast-container .content .title-and-author h3 {
  margin-bottom: 3px;
  margin-top: 0;
}
:host ion-item.item div.podcast-container .content h3 {
  word-wrap: normal;
  white-space: normal;
  line-height: 1.4;
}
:host ion-item.item div.podcast-container .content small {
  display: flex;
  color: var(--ion-color-medium);
}
:host ion-item.item div.podcast-container .content p {
  word-wrap: normal;
  color: var(--ion-color-dark);
  line-height: 1.5 !important;
}
:host ion-item.item div.podcast-container .content-player {
  display: flex;
  padding: var(--small-item-padding);
  padding-top: 0;
}
:host ion-item.item div.podcast-container .content-player ion-button {
  --background: transparent;
  font-size: 20px;
  --padding-start: 5px;
  --padding-end: 5px;
  margin: 8px 5px;
  min-height: 40px;
  height: 40px;
  width: 40px;
  flex: 0 0 40px;
  --border-radius: 50%;
}
:host ion-item.item div.podcast-container .content-player ion-button.back-time {
  margin-left: 0;
}
:host ion-item.item div.podcast-container .content-player ion-button.download {
  margin-right: 0;
}
:host ion-item.item div.podcast-container .content-player ion-button .icon-empatica-back-time {
  color: #181a18;
  font-size: 20px;
}
:host ion-item.item div.podcast-container .content-player ion-button ion-icon {
  color: #181a18;
}
:host ion-item.item div.podcast-container .content-player ion-button.ios, :host ion-item.item div.podcast-container .content-player ion-button.md {
  min-height: 30px;
  height: 30px;
  width: 30px;
  flex: 0 0 30px;
}
:host ion-item.item div.podcast-container .content-player .content-range {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
  padding: 0 15px;
  margin-top: 15px;
}
:host ion-item.item div.podcast-container .content-player .content-range .range-playtime {
  display: flex;
  justify-content: space-between;
  padding: 0;
}
:host ion-item.item div.podcast-container .content-player .content-range .range-playtime ion-label {
  font-size: 12px;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/episode/episode.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;AACE;EACE,kBAAA;EACA,gBAAA;EAMA,mBAAA;AAJJ;AAAI;EACE,+CAAA;AAEN;AAEI;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,qBAAA;AAAN;AACM;EACE,kCAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;AACR;AACQ;EACE,kBAAA;AACV;AAAU;EACE,mCAAA;EACA,UAAA;AAEZ;AACQ;EACE,aAAA;AACV;AACQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AACV;AAAU;EACE,WAAA;AAEZ;AAAc;EACE,WAAA;EACA,mBAAA;AAEhB;AAAc;EACE,kBAAA;AAEhB;AAGQ;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;AADV;AAGU;EACE,kBAAA;EACA,aAAA;AADZ;AAKQ;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;AAHV;AAMQ;EACE,aAAA;EACA,8BAAA;AAJV;AAOQ;EACE,iBAAA;EACA,4BAAA;EACA,2BAAA;AALV;AASM;EACE,aAAA;EACA,kCAAA;EACA,cAAA;AAPR;AAQQ;EASE,yBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,oBAAA;AAdV;AAHU;EACE,cAAA;AAKZ;AAFU;EACE,eAAA;AAIZ;AASU;EACE,cAAA;EACA,eAAA;AAPZ;AASU;EACE,cAAA;AAPZ;AASU;EAEE,gBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AARZ;AAWQ;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AATV;AAWU;EACE,aAAA;EACA,8BAAA;EACA,UAAA;AATZ;AAUY;EACE,eAAA;EACA,UAAA;AARd","sourcesContent":[":host {\n  display: block;\n\n  ion-item.item {\n    --padding-start: 0;\n    --padding-end: 0;\n\n    &.space-between-elements {\n      border-bottom: 1px solid var(--ion-color-light);\n    }\n\n    padding-bottom: 1em;\n    div.podcast-container {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      margin: 0;\n      white-space: pre-wrap;\n      .content {\n        padding: var(--small-item-padding);\n        padding-bottom: 0;\n        display: flex;\n        justify-content: space-between;\n\n        .controls {\n          margin-right: 12px;\n          ion-spinner {\n            color: var(--cms-button-text-color);\n            width: 1em;\n          }\n        }\n        .controls-and-title {\n          display: flex;\n        }\n        .image {\n          width: 85px;\n          height: 85px;\n          max-width: 85px;\n          margin-right: 16px;\n          flex-basis: 85px;\n          flex-grow: 0;\n          flex-shrink: 0;\n          image-loader {\n            width: 100%;\n            ::ng-deep {\n              app-loading {\n                width: 100%;\n                min-height: initial;\n              }\n              img {\n                border-radius: 8px;\n              }\n            }\n          }\n        }\n        .title-and-author {\n          display: flex;\n          justify-content: center;\n          flex-direction: column;\n\n          h3 {\n            margin-bottom: 3px;\n            margin-top: 0;\n          }\n        }\n\n        h3 {\n          word-wrap: normal;\n          white-space: normal;\n          line-height: 1.4;\n        }\n\n        small {\n          display: flex;\n          color: var(--ion-color-medium);\n        }\n\n        p {\n          word-wrap: normal;\n          color: var(--ion-color-dark);\n          line-height: 1.5 !important;\n        }\n      }\n\n      .content-player {\n        display: flex;\n        padding: var(--small-item-padding);\n        padding-top: 0;\n        ion-button {\n          &.back-time {\n            margin-left: 0;\n          }\n\n          &.download {\n            margin-right: 0;\n          }\n\n          --background: transparent;\n          font-size: 20px;\n          --padding-start: 5px;\n          --padding-end: 5px;\n          margin: 8px 5px;\n          min-height: 40px;\n          height: 40px;\n          width: 40px;\n          flex: 0 0 40px;\n          --border-radius: 50%;\n          .icon-empatica-back-time {\n            color: #181a18;\n            font-size: 20px;\n          }\n          ion-icon {\n            color: #181a18;\n          }\n          &.ios,\n          &.md {\n            min-height: 30px;\n            height: 30px;\n            width: 30px;\n            flex: 0 0 30px;\n          }\n        }\n        .content-range {\n          display: flex;\n          flex-direction: column;\n          justify-content: center;\n          flex-grow: 1;\n          padding: 0 15px;\n          margin-top: 15px;\n\n          .range-playtime {\n            display: flex;\n            justify-content: space-between;\n            padding: 0;\n            ion-label {\n              font-size: 12px;\n              padding: 0;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
